import { maybeAutoSubscribeToPush, primeServiceWorkerStorage } from './pushNotifications.js';

const API_BASE = import.meta.env.VITE_API_BASE ?? '';

let _prompt = null;

window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  _prompt = e;
  window.dispatchEvent(new Event('pwa:installready'));
});

export function getInstallPrompt() { return _prompt; }
export function clearInstallPrompt() { _prompt = null; }

// ── Tracking de instalaciones/desinstalaciones ──────────────────────────────

export function detectDevice() {
  const ua = navigator.userAgent;
  if (/tablet|ipad|playbook|silk|(android(?!.*mobile))/i.test(ua)) return 'tablet';
  if (/mobile|android|iphone|ipod|blackberry|opera mini|iemobile/i.test(ua)) return 'mobile';
  return 'desktop';
}

export function getDeviceId() {
  let id = localStorage.getItem('pwa_device_id');
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem('pwa_device_id', id);
  }
  return id;
}

// Refresca el device_id y la URL del back que puede leer el service worker,
// en cada carga (sana también a dispositivos ya suscriptos antes de esto).
primeServiceWorkerStorage(getDeviceId());

function pingPwa(source) {
  fetch(`${API_BASE}/api/pwa/ping`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ device_id: getDeviceId(), device_type: detectDevice(), source }),
  }).catch(() => {});
}

window.addEventListener('appinstalled', () => {
  pingPwa('install');
  maybeAutoSubscribeToPush(getDeviceId(), detectDevice());
});

if (window.matchMedia('(display-mode: standalone)').matches) {
  const HEARTBEAT_MS = 24 * 60 * 60 * 1000;
  const last = Number(localStorage.getItem('pwa_last_ping') || 0);
  if (Date.now() - last >= HEARTBEAT_MS) {
    pingPwa('heartbeat');
    localStorage.setItem('pwa_last_ping', String(Date.now()));
  }
  maybeAutoSubscribeToPush(getDeviceId(), detectDevice());
}
